﻿$(function () {
    console.log("Inicjalizacja cookies");
    $('button.close').on('click', function () {
        console.log("Ukrywanie cookies");
        $("#cookies").hide(); //komentarz        
    });
});